import React from 'react';

const FormInput = ({ 
  type = 'text', 
  placeholder, 
  register, 
  error, 
  name,
  ...rest 
}) => {
  return (
    <div className="auth-form-group">
      <input
        type={type}
        placeholder={placeholder}
        className={`auth-input ${error ? 'auth-input-error' : ''}`}
        {...register(name)}
        {...rest}
      />
      {error && (
        <span className="auth-error-message">{error.message}</span>
      )}
    </div>
  );
};

export default FormInput;

